import { ReadonlySignal, useComputed } from '@preact/signals-react';

export function useProxyActions(
  parsedHtml: ReadonlySignal<HTMLDivElement>,
  runInIframe: (callback: (doc: Document, win: Window) => void) => void,
) {
  const sectionId = useComputed(() => {
    if (parsedHtml?.value?.innerHTML) {
      const section = parsedHtml.value.querySelector(`[id*="loomi_"]`);
      if (section) {
        return section.id;
      }
    }
    return ``;
  });

  const showAddedElements = () => {
    runInIframe((doc) => {
      const section = doc.querySelector(`#${sectionId.peek()}`);
      if (section) {
        const dialog = section.querySelector(`dialog`);
        if (dialog && dialog?.[`show`]) {
          dialog?.[`show`]?.();
          return;
        }
        section.scrollIntoView({
          behavior: `smooth`,
          block: `start`,
        });
      }
    });
  };

  return { showAddedElements };
}
